import Resources from "../Resources";

/* eslint-disable no-shadow */
export const IRM_TENANT_ID = "a134d99a-b0eb-492f-af9d-ad88fe44fb5c";
export const IRM_CLIENT_ID = "7f157b52-d2ea-4dfd-ba41-8b74fe614002";
export const ONE_YEAR_IN_MONTHS = 12;

export const roleIDs = {
  nbgo: "3ce3d2fa-c74e-47d9-90c0-8665127f9894",
  channelSupport: "7c589128-e017-47cd-a901-794ce725239e",
  finance: "d4532694-f46e-4ccf-b65e-2b54cffbcb2f",
  irm: "405030d7-c520-48fb-aaf9-ba1ceba74231",
  bankEmployee: "98463413-e501-44e7-9a91-a9bfabbc41e5",
  uw: "79647f6b-0d25-46b4-8186-5e295ceb39eb",
  admin: "1c5f2a87-4ebd-461a-af13-effaadd216a7",
  superAdmin: "d989ef27-d1d3-4f95-b188-3de00fc64144",
  afliAuth: "88828794-471d-41e8-b590-aa66d9fb88a1",
  partnerAdmin: "a5acb291-d541-41d1-a126-c514f39dce8b"
};

export const partners = {
  IDBI: "idbi",
  FEDERAL: "federal",
  JIO: "jfs",
  SREI: "srei",
  DIRECT: "direct",
  CAPRI: "capri",
  SOLFIN: "solfin"
};

export enum CoverType {
  JOINT = "joint",
  PROPORTIONATE = "proportionate",
  SINGLE = "single"
}

export enum JointCoverageType {
  YES = "yes",
  NO = "no"
}

export const labels = {
  joint: {
    text: "The creation of Joint Life member, cannot be undone",
    cta: "Click on Yes if you wish to proceed"
  },
  proportionate: {
    text: "The creation of Proportionate Life member, cannot be undone",
    cta: "Click on Yes if you wish to proceed"
  },
  proportionateEligibility: {
    text_GLS: "Loan share should not be below 5L",
    text_GHS: "Loan share should not be below 2L",
    text_JFS: "Loan share should not be below 3L",
    text_SREI: "Loan share should not be below 25L"
  }
};

export enum VariableConstants {
  "BISMINLOAN" = 500000,
  "GHS_MIN_LOAN" = 200000,
  "JFS_MIN_LOAN" = 300000,
  "SREI_MIN_LOAN" = 2500000
}

export const masterPolicyHolderName = {
  IDBI: "IDBI Bank",
  FEDERAL: "Federal Bank",
  JFS: "JIO Finance Limited"
};

export const masterPolicyNumber = {
  isStaff_FEDERAL: "MP005079",
  nonStaff_FEDERAL: "MP005052",
  IDBI: "MP005080",
  prodIsFederal: "MP000008"
};

export const url = {
  create_lead_details: "/create-lead-details"
};

export const medicalQuestionExcludedQuestionID = ["1021"];

export const accessCreateLeadOption = [partners.SREI];

export const showPartnerLogo = {
  [partners.IDBI]: Resources.images.Dashboard.idbiLogo,
  [partners.FEDERAL]: Resources.images.Dashboard.federalLogo
};

export const RiderPlanOption = {
  DEATH: "death",
  DISABILITY: "disability",
  COMPREHENSIVE: "comprehensive",
  EMISUPPORT: "emisupport"
} as const;

export const RiderSubPlanOption = {
  ADB: "ADB",
  ADBPlus: "ADBPlus",
  PDB: "PDB",
  PDBPlus: "PDBPlus"
} as const;

export type RiderSubPlanOptionType = (typeof RiderSubPlanOption)[keyof typeof RiderSubPlanOption];

export const RiderBenefitType = {
  ACCELERATED: "accelerated",
  ADDITIONAL: "additional"
} as const;

export const validSubPlans: Record<string, (RiderSubPlanOptionType | null)[]> = {
  [RiderPlanOption.DEATH]: [RiderSubPlanOption.ADB, RiderSubPlanOption.ADBPlus],
  [RiderPlanOption.DISABILITY]: [RiderSubPlanOption.PDB, RiderSubPlanOption.PDBPlus],
  [RiderPlanOption.COMPREHENSIVE]: [null],
  [RiderPlanOption.EMISUPPORT]: [null]
};
